export enum CampaignStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
}

export enum MnoStatus {
  Review = 'REVIEW',
  Rejected = 'REJECTED',
  Registered = 'REGISTERED',
  Suspended = 'SUSPENDED',
}

export enum RoutingMode {
  Common = 'COMMON',
  Dedicated = 'DEDICATED',
}

export enum SenderIdType {
  LongCode = 'LONGCODE',
  ShortCode = 'SHORTCODE',
}
